module.exports = __webpack_public_path__ + "src/assets/games/15/101.jpg";